import { IAnalyticsSubmission } from '../types'

export enum XMetricsActionTypes {
  FETCH_REQUEST = 'pcr/xMetrics/FETCH_REQUEST',
  FETCH_SUCCESS = 'pcr/xMetrics/FETCH_SUCCESS',
  FETCH_ERROR = 'pcr/xMetrics/FETCH_ERROR',
}

export interface IXMetricsState {
  isFetching: boolean
  errors?: object | string
  xMetricsById: Record<number, IXMetrics>
  xMetricIdsByCampaignId: Record<number, ReadonlyArray<number>>
  xMetricsSummaryByCampaignId: Record<number, IXMetricsSummary>
}

export interface IXMetrics extends IAnalyticsSubmission {
  purchase_amount: number
  purchase_amount_currency: string
  impressions?: number
  impressions_pct?: number
  cpm?: number
  cpv?: number
  likes?: number
  comments?: number
  shares?: number
  engagement?: number
  cpe?: number
  engagement_pct?: number
}

export interface IXMetricsSummary {
  count: number | null
  total_purchase_amount: number | null
  total_followers: number | null
  engagement?: number
  engagement_pct?: number
  likes?: number
  comments?: number
  shares?: number
  impressions?: number
  impressions_pct?: number
  cpv?: number
  cpm?: number
  cpe?: number
}

export interface IXMetricsResponse {
  items: ReadonlyArray<IXMetrics>
  metadata: IXMetricsSummary
}
